/* VARENZO accessibility helpers: inert handling for hidden panels, mobile drawer focus management,
   keyboard access to the Men mega menu, and the footer cookie-preferences opener. */
(function () {
  "use strict";
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function syncInert(el) {
    if (el.getAttribute("aria-hidden") === "true") el.setAttribute("inert", "");
    else el.removeAttribute("inert");
  }
  function watchHidden(el) {
    if (!el) return;
    syncInert(el);
    new MutationObserver(function () { syncInert(el); }).observe(el, { attributes: true, attributeFilter: ["aria-hidden"] });
  }

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn); else fn();
  }

  document.addEventListener("click", function (e) {
    var t = e.target && e.target.closest && e.target.closest("[data-v-cookie-prefs]");
    if (!t || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
    if (window.VarenzoConsent && typeof window.VarenzoConsent.open === "function") {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.VarenzoConsent.open(t);
    }
  }, true);

  ready(function () {
    watchHidden(document.getElementById("v-mega-menu"));
    watchHidden(document.getElementById("v-mobile-nav-drawer"));
    watchHidden(document.getElementById("v-cookie-consent"));

    var mega = document.getElementById("v-mega-menu");
    var trigger = document.querySelector("[data-mega-trigger]");
    if (trigger && mega) {
      var hint = document.createElement("span");
      hint.className = "v-sr-only";
      hint.id = "v-mega-hint";
      hint.textContent = "Press Down Arrow to browse categories.";
      trigger.parentNode.insertBefore(hint, trigger.nextSibling);
      trigger.setAttribute("aria-describedby", "v-mega-hint");
      trigger.addEventListener("keydown", function (e) {
        if (e.key !== "ArrowDown") return;
        e.preventDefault();
        trigger.dispatchEvent(new Event("focus"));
        window.setTimeout(function () {
          var first = mega.querySelector(".v-mega-panel:not([hidden]) a[href]");
          if (first) first.focus();
        }, 30);
      });
      document.addEventListener("keydown", function (e) {
        if (e.key !== "Escape") return;
        window.setTimeout(function () {
          if (mega.classList.contains("is-open") && document.activeElement === trigger) {
            mega.classList.remove("is-open", "is-swapping");
            mega.setAttribute("aria-hidden", "true");
            trigger.setAttribute("aria-expanded", "false");
          }
        }, 0);
      });
    }

    var drawer = document.getElementById("v-mobile-nav-drawer");
    var toggle = document.getElementById("v-mobile-menu-toggle");
    if (drawer && toggle) {
      new MutationObserver(function () {
        if (drawer.classList.contains("is-open")) {
          window.setTimeout(function () {
            var first = drawer.querySelector("button,a[href]");
            if (first) first.focus();
          }, 50);
        }
      }).observe(drawer, { attributes: true, attributeFilter: ["class"] });
      document.addEventListener("keydown", function (e) {
        if (e.key !== "Tab" || !drawer.classList.contains("is-open")) return;
        var items = [toggle].concat(Array.prototype.slice.call(drawer.querySelectorAll(FOCUSABLE))).filter(function (el) { return el.offsetParent !== null; });
        var first = items[0], last = items[items.length - 1];
        var a = document.activeElement;
        if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
        else if (!drawer.contains(a) && a !== toggle) { e.preventDefault(); first.focus(); }
      });
    }
  });
})();
